import { createGlobalStyle } from 'styled-components'

// noinspection CssInvalidPropertyValue
const GlobalCss = createGlobalStyle`
  button {
    font: inherit;
  }

  html {
    height: -webkit-fill-available;
  }

  body {
    min-height: 100vh;
    min-width: 320px;
    min-height: -webkit-fill-available;
    display: flex;
    background: ${({ theme }) => theme.palette.background.default};
    color: ${({ theme }) => theme.palette.text.primary};
  }

  #root {
    width: 100%;
    display: flex;
    flex: 1;
  }

  b {
    font-weight: 600;
  }

  a {
    color: inherit;
    text-decoration: none;
  }
  //.react-horizontal-scrolling-menu--scroll-container {
  //  overflow: hidden;
  //}
`

export default GlobalCss
